import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage, BasePanelPageStyle} from "../BasePanelPage";
import {Messages} from "../../../../Messages";
import {subscribeFlowState} from "../../../inline-subscription/SubscribeFlowState";
import {MerchantButton} from "../../../../common/MerchantButton";
import {authService} from "../../../../../client/connection/Services";
import {collapseIframe} from "../../../../widget/misc/WidgetUtils";
import {styleRule} from "../../../../../stem-core/src/decorators/Style";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {Router} from "../../../../../stem-core/src/ui/Router";
import {INLINE_SUBSCRIPTION_URLS} from "../../../PaywallConstants";
import {Link} from "../../../../../stem-core/src/ui/UIPrimitives";
import {MessageElement} from "../../../../widget/ui/MessageElement";
import {subscribePlanController} from "../../../inline-subscription/SubscribePlanController";
import {NOOP_FUNCTION} from "../../../../../blink-sdk/utils/Utils";


export class SubscribeReviewOrderPanelStyle extends BasePanelPageStyle {
    @styleRule
    reviewItem = {
        marginTop: 14,
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_NORMAL,
    };

    @styleRule
    reviewItemTitleContainer = {
        display: "flex",
        justifyContent: "space-between",
    };

    @styleRule
    reviewItemDescription = {
        color: this.themeProps.MERCHANT_TEXT_SECONDARY_COLOR,
    };

    @styleRule
    reviewItemTitle = {
        textTransform: "uppercase",
        marginBottom: 18,
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_BOLD,
    };

    @styleRule
    nameOnAddress = {
        marginBottom: 4,
    };

    @styleRule
    addressDetails = {
        display: "flex",
        flexDirection: "column",
    };

    @styleRule
    link = this.themeProps.PAYWALL_LINK;

    @styleRule
    lineSeparator = {
        width: "100%",
        borderBottom: "1px solid " + this.themeProps.MERCHANT_FRAME_HEADER_BORDER_COLOR,
        marginTop: 14,
    }
}

@registerStyle(SubscribeReviewOrderPanelStyle)
export class SubscribeReviewOrderPanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.reviewOrder
        }
    }

    render() {
        const {styleSheet} = this;
        const {selectedSubscriptionOffer, shippingAddress, discountCode} = subscribeFlowState.getSubscriptionInfo();
        const discountInfo = subscribeFlowState.getDiscountInfo(selectedSubscriptionOffer);
        const finalPrice = discountInfo ? selectedSubscriptionOffer.formatPrice(discountInfo.finalPrice) : "-";
        const cycle = selectedSubscriptionOffer.getCycleDuration();

        return [
            <div className={styleSheet.reviewItem} testId="subscriptionPlanSection">
                <div className={styleSheet.reviewItemTitleContainer}>
                    <div className={styleSheet.reviewItemTitle}>{Messages.subscriptionPlan}</div>
                    <Link value={Messages.change} className={styleSheet.link} testId="changeButton"
                          onClick={() => {
                              subscribePlanController.update({onSelectCancel: () => Router.back()});
                              Router.changeURL(INLINE_SUBSCRIPTION_URLS.subscriptionsOverview);
                          }}/>
                </div>
                <MessageElement className={styleSheet.reviewItemDescription}
                                args={[selectedSubscriptionOffer.getCoverageName(), finalPrice, cycle]}
                                message={Messages.subscriptionPlanDescription} />
            </div>,
            discountCode ? [
                <div className={styleSheet.lineSeparator}/>,
                <div className={styleSheet.reviewItem} testId="discountSection">
                    <div className={styleSheet.reviewItemTitleContainer}>
                        <div className={styleSheet.reviewItemTitle}>{Messages.discountCode}</div>
                    </div>
                    <MessageElement className={styleSheet.reviewItemDescription}
                                    message={Messages.discountCodeApplied(discountCode)} />
                </div>
            ] : null,
            selectedSubscriptionOffer.shouldCollectAddress() ? [
                <div className={styleSheet.lineSeparator}/>,
                <div className={styleSheet.reviewItem} testId="addressSection">
                    <div className={styleSheet.reviewItemTitleContainer}>
                        <div className={styleSheet.reviewItemTitle}>{Messages.address}</div>
                        <Link value={Messages.edit} className={styleSheet.link} testId="editButton"
                              onClick={() => Router.changeURL(INLINE_SUBSCRIPTION_URLS.address)}/>
                    </div>
                    <div className={styleSheet.reviewItemDescription}>
                        <div className={styleSheet.nameOnAddress}>{shippingAddress.getRecipientName()}</div>
                        <div className={styleSheet.addressDetails}>{shippingAddress}</div>
                    </div>
                </div>
            ] : null,
            <div className={styleSheet.lineSeparator}/>,
            <div className={styleSheet.reviewItem} testId="paymentMethodSection">
                <div className={styleSheet.reviewItemTitle}>{Messages.payment}</div>
                <MessageElement className={styleSheet.reviewItemDescription} args={[finalPrice, cycle]}
                                message={Messages.subscribePaymentDescription} />
            </div>,
            <MerchantButton onClick={() => this.handlePrimaryButtonClick()} className={styleSheet.button}>
                {Messages.continueToPayment}
            </MerchantButton>,
            <div className={styleSheet.center}>
                <div onClick={() => {
                    Router.back();
                    subscribePlanController.update({onSelectCancel: NOOP_FUNCTION});
                }} className={styleSheet.secondaryButton}>
                    {Messages.back}
                </div>
            </div>
        ];
    }

    handlePrimaryButtonClick() {
        Router.changeURL(INLINE_SUBSCRIPTION_URLS.paymentDetails);
    }

    async onMount() {
        super.onMount();

        authService.onAuthenticationChange(() => {
            if (!authService.isAuthenticated()) {
                collapseIframe();
            }
        });
        this.attachListener(subscribeFlowState, "requestsFinished", () => {
            this.redraw();
        });
    }
}
